import logger from '@greenlight/logger';
import { useEffect } from 'react';

export function useCaptureErrorLoadingPlaid(
  error: ErrorEvent | null,
  createError: (payload: {
    message: string;
    registrationStep: string;
    error: boolean;
  }) => void
) {
  useEffect(() => {
    if (error) {
      logger.error('There was an issue loading the Plaid component');
      createError({
        message: error.message,
        registrationStep: 'set_funding_account',
        error: true
      });
    }
  }, [error]);
}
